import { render, staticRenderFns } from "./Promotion_table_avg.vue?vue&type=template&id=153dcd30&"
import script from "./Promotion_table_avg.vue?vue&type=script&lang=js&"
export * from "./Promotion_table_avg.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_table_avg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports